import axios from 'axios'
const { Liquid } = require('liquidjs');


const LIQUID_ENGINE = Symbol.for("lw.pagebuilder.liquid");

const globalSymbols = Object.getOwnPropertySymbols(global);

const hasLiquidEngine = (globalSymbols.indexOf(LIQUID_ENGINE) > -1);

if(window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}
if(window.HTMLCollection && !HTMLCollection.prototype.forEach) {
  HTMLCollection.prototype.forEach = Array.prototype.forEach;
}

const cache = new Map();
const regex = /\/api/gi;
const server = global.server.replace(regex,"/liquid")

if (!hasLiquidEngine) {
  const engine = new Liquid({
    cache: true,
    fs: {
      readFile(file) {
        if (!cache.has(file)) {
          let template = '';
          let templateScript = document.querySelector("#cache-" + file);

          // TODO Search for script tin authoring for now
          if (templateScript) {
            template = templateScript.innerHTML;
          } else {
            template = axios.get(server + file).then(res => res.data);
          }

          cache.set(file, template);
        }
        return Promise.resolve(cache.get(file));
      },
      exists(file) {
        //Note: If false, doesn't progress to read the file
        return true;
      },
      resolve(root, file, ext) {
        return file;
      }
    }
  });

  engine.registerFilter('image_url', v => global.imagePath + v)
  
  global[LIQUID_ENGINE] = {
    renderFile(template, data) {
      return engine.renderFile(template, data)
    }
  };
}
const LiquidCompiler = {};

Object.defineProperty(LiquidCompiler, "instance", {
  get: function(){
    return global[LIQUID_ENGINE];
  }
});

Object.freeze(LiquidCompiler);

export default LiquidCompiler.instance;